import { combineReducers } from '@ngrx/store';

import { UiWidgetsRootReducer as ui } from '@shared/widgets/store/reducers/ui';
import { alertReducer as alert } from '@shared/widgets/store/reducers/alerts.reducer';

export const widgetsRootReducer = combineReducers({
  alert,
  ui
});

